import { SwalMessage } from "../js/Tools";

var Hotels = function () {


    const ElementHandle = function () {
        const form = document.querySelector('[data-hotel-search]');

        if (!form) {
            return;
        }

        form.querySelector("[data-search-date]").flatpickr({
            mode: "range",
            minDate: "today",
            dateFormat: "d.m.Y",
            locale: "tr",
        });

        // çocuk doğum tarihi
        $("[data-search-child-date]").flatpickr({
            dateFormat: "d.m.Y",
            locale: "tr",
            maxDate: "today",
        });
    }


    const ChildrenDates = function () {


        const elementList = document.querySelector('#childrens-dates');

        const addChildrenDate = function (value = null) {
            let clone = elementList.querySelector('[data-search-child-date-template]').cloneNode(true);
            clone.classList.remove('d-none');
            clone.removeAttribute('data-search-child-date-template');


            if (value != null) {
                clone.querySelector('input').value = value;
            }


            elementList.appendChild(clone);

            ElementHandle();
        }

        const removeChildrenDate = function () {
            let lastElement = elementList.lastElementChild;
            if (lastElement != null && lastElement != undefined) {

                if (!lastElement.classList.contains('d-none')) {
                    lastElement.remove();
                    return;
                }
            }
        }

        $(document).on('click', '#children-add-btn', function (e) {
            e.preventDefault();
            let childCount = document.querySelector('#guests-count-children').innerText;


            let elementListCount = elementList.childElementCount - 1;

            if (elementListCount >= hotelSettings.maxChild) {
                // SwalMessage(
                //     {
                //         type: "error",
                //         text: "Çocuk sayısı en fazla " + hotelSettings.maxChild + " olabilir.",
                //         confirmButton: translate.ok_button
                //     },
                //     function () {
                //         // location.reload();
                //     }
                // );
                return;
            } else {
                addChildrenDate();
            }

        });


        $(document).on('click', '#children-subs-btn', function (e) {
            e.preventDefault();
            let childCount = document.querySelector('#guests-count-children').innerText;

            removeChildrenDate();
        });


        const childrenCountEl = document.querySelector("#guests-count-children");
        if (childrenCountEl.innerText > 0) {
            let childDatesEl = document.querySelector('#childrens-dates').getAttribute('data-child-dates');
            let childDates = childDatesEl.split(',');
            for (let i = 0; i < childrenCountEl.innerText; i++) {
                console.log(childDates[i]);
                addChildrenDate(childDates[i]);
            }
        }
    }



    const NullCheck = function (value) {
        if (value == null || value == undefined || value == '') {
            return true;
        }

        return false;
    }

    const SearchHandle = function () {
        const form = document.querySelector('[data-hotel-search]');

        if (!form) {
            return;
        }

        const provinceSelectElement = form.querySelector('[data-search-where]');
        const dateInputElement = form.querySelector('[data-search-date]');

        const guestFormElement = form.querySelector('[data-search-guest]');
        const adultInputElement = guestFormElement.querySelector('[data-search-guest-adult]');
        const childrenInputElement = guestFormElement.querySelector('[data-search-guest-children]');
        // const roomInputElement = guestFormElement.querySelector('[data-search-guest-room]');

        const submitButtonElement = form.querySelector('[data-search-submit]');


        $(submitButtonElement).on('click', function (event) {
            event.preventDefault();

            let provinceValue = provinceSelectElement.value;
            // console.log('province', provinceValue);
            if (NullCheck(provinceValue)) {
                SwalMessage(
                    {
                        type: "error",
                        text: "Nereye gitmek istediğinizi seçmelisiniz.",
                        confirmButton: translate.ok_button
                    },
                    function () {
                        // location.reload();
                    }
                );
                return;
            }

            let dateValue = dateInputElement.value;
            // console.log('date', dateValue);
            // if (NullCheck(dateValue)) {
            //     SwalMessage(
            //         {
            //             type: "error",
            //             text: "Tarih aralığı girmelisiniz.",
            //             confirmButton: translate.ok_button
            //         },
            //         function () {
            //             // location.reload();
            //         }
            //     );
            //     return;
            // }

            let adultValue = adultInputElement.querySelector('#guests-count-adults').innerText;
            // console.log('adult', adultValue);

            let childValue = childrenInputElement.querySelector('#guests-count-children').innerText;
            // console.log('child', childValue);

            let childDates = [];
            let childDateElements = document.querySelector('#childrens-dates');
            childDateElements.querySelectorAll('[data-search-child-date]').forEach(function (element) {
                let value = element.value;
                if (!NullCheck(value)) {
                    childDates.push(value);
                }
            });
            // console.log('childDates', childDates);

            var data = {
                province: provinceValue,
                date: dateValue,
                adult: adultValue,
            };

            if (childDates.length > 0) {
                data.child = childValue;
                data.childDates = childDates;
            }


            // console.log('data', data);

            // Veriyi URL formatına dönüştürme
            var queryString = Object.keys(data).map(
                key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            ).join('&');

            // location.href = `${baseUrl}/hotel/search?${queryString}`;
            location.href = `${baseUrl}/hotel?${queryString}`;

        })



    }


    // Oda seçin
    $(document).on('click', '[data-hotel-room-select]', function (e) {
        e.preventDefault();

        let room = document.querySelector('[data-rooms] [data-room-id="0"]');

        if (room == null || room == undefined) {
            return;
        }

        // room'a focus yap
        room.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
        });

    });

    // rezerasyon yap butonu
    $(document).on('click', '[data-room-reservation]', function (e) {
        e.preventDefault();

        const form = document.querySelector('[data-hotel-search]');

        if (!form) {
            return;
        }

        const provinceSelectElement = form.querySelector('[data-search-where]');
        const dateInputElement = form.querySelector('[data-search-date]');

        const guestFormElement = form.querySelector('[data-search-guest]');
        const adultInputElement = guestFormElement.querySelector('[data-search-guest-adult]');
        const childrenInputElement = guestFormElement.querySelector('[data-search-guest-children]');
        // const roomInputElement = guestFormElement.querySelector('[data-search-guest-room]');

        const hotelName = document.querySelector('[data-hotel-name]');
        const hotelId = hotelName.getAttribute('data-hotel-id');
        const contractHotelId = hotelName.getAttribute('data-hotel-contract-id');
        const session = hotelName.getAttribute('data-session');
        const provinceName = hotelName.getAttribute('data-hotel-district');
        const userId = hotelName.getAttribute('data-user-id');

        const submitButtonElement = form.querySelector('[data-search-submit]');


        if (provinceSelectElement.value == null || provinceSelectElement.value == undefined || provinceSelectElement.value == '') {
            provinceSelectElement.focus();

            provinceSelectElement.value = hotelName.innerText + ', ' + provinceName;
            return;
        }

        if (dateInputElement.value == null || dateInputElement.value == undefined || dateInputElement.value == '') {
            dateInputElement.focus();
            return;
        }

        if (this.getAttribute('data-room-name') == null || this.getAttribute('data-room-name') == undefined) {
            submitButtonElement.click();
            return;
        }



        // rezerasyon yapılacak

        let roomName = this.getAttribute('data-room-name');


        fetch(`${apiUrl}/HotelReservation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hotelId: hotelId,
                contractHotelId: contractHotelId,
                room: roomName,
                session: session,
                userId: userId,
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);

                if (data.code == 200) {
                    SwalMessage(
                        {
                            type: "success",
                            text: data.text,
                            confirmButton: translate.ok_button
                        },
                        function () {

                        }
                    );

                    if (data.redirectUrl != null && data.redirectUrl != undefined) {
                        window.location = data.redirectUrl;
                    }

                } else {
                    SwalMessage(
                        {
                            type: "error",
                            text: data.text,
                            confirmButton: translate.ok_button
                        },
                        function () {
                            // location.reload();
                        }
                    );
                }

            })
            .catch((error) => {
                // console.error('Error:', error);
            });

    });



    return {
        init: function () {
            if (document.querySelector('[data-hotel-search]')) {
                ElementHandle();
                SearchHandle();

                ChildrenDates();
            }
        }
    }
}();


var Reservation = function () {


    const Step1 = function () {

        const form = document.querySelector('[data-form-step="1"]');

        if (!form) {
            return;
        }

        const reservationNumber = form.getAttribute('data-reservation-number');

        const submitButtonElement = form.querySelector('[data-form-submit]');

        $(submitButtonElement).on('click', function (event) {
            event.preventDefault();

            let formData = new FormData(form);
            formData.append('reservationNumber', reservationNumber);

            // formData validation
            let error = false;
            form.querySelectorAll('input').forEach(function (element) {
                if (element.hasAttribute('required')) {
                    if (element.value == null || element.value == undefined || element.value == '') {
                        element.classList.add('border-danger');
                        element.focus();
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        });
                        SwalMessage(
                            {
                                type: "error",
                                text: "Lütfen zorunlu alanları doldurunuz.",
                                confirmButton: translate.ok_button
                            },
                            function () {

                            }
                        );
                        error = true;
                        return;
                    } else {
                        element.classList.remove('border-danger');
                    }
                }
            });

            // telefon value ataması
            let phoneElement = form.querySelector('[mask-type="tel"]');
            if (phoneElement != null && phoneElement != undefined) {
                formData.forEach(function (value, key) {
                    if (key.indexOf('phone') != -1) {
                        formData.set(key, phoneElement.getAttribute('data-value'));
                    }
                });
            }

            if (error) {
                return;
            }

            fetch(form.getAttribute('action'), {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);

                    if (data.code == 200) {
                        // ToastMessage("1", '', xhr.responseJSON.text ?? xhr.responseJSON.message)
                        if (data.redirectUrl != null && data.redirectUrl != undefined) {
                            window.location = data.redirectUrl;
                        }
                    } else {
                        SwalMessage(
                            {
                                type: "error",
                                text: data.text,
                                confirmButton: translate.ok_button
                            },
                            function () {
                                if (data.redirectUrl != null && data.redirectUrl != undefined) {
                                    window.location = data.redirectUrl;
                                }
                            }
                        );
                    }

                })
                .catch((error) => {
                    // console.error('Error:', error);
                });

        })

    }

    const Step2 = function () {

        const form = document.querySelector('[data-form-step="2"]');
        if (!form) {
            return;
        }

        const reservationNumber = form.getAttribute('data-reservation-number');
        const submitButtonElement = form.querySelector('[data-form-submit]');

        $(submitButtonElement).on('click', function (event) {
            event.preventDefault();

            let formData = new FormData(form);
            formData.append('reservationNumber', reservationNumber);

            // formData validation
            let error = false;
            form.querySelectorAll('input, textarea').forEach(function (element) {
                if (element.hasAttribute('required')) {
                    if (element.value == null || element.value == undefined || element.value == '') {
                        element.classList.add('border-danger');
                        element.focus();
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        });
                        SwalMessage(
                            {
                                type: "error",
                                text: "Lütfen zorunlu alanları doldurunuz.",
                                confirmButton: translate.ok_button
                            },
                            function () {

                            }
                        );
                        error = true;
                        return;
                    } else {
                        element.classList.remove('border-danger');
                    }
                }
            });

            // telefon value ataması
            let phoneElement = form.querySelector('[mask-type="tel"]');
            if (phoneElement != null && phoneElement != undefined) {
                formData.forEach(function (value, key) {
                    if (key.indexOf('phone') != -1) {
                        formData.set(key, phoneElement.getAttribute('data-value'));
                    }
                });
            }

            if (error) {
                return;
            }

            fetch(form.getAttribute('action'), {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);

                    if (data.code == 200) {
                        // ToastMessage("1", '', xhr.responseJSON.text ?? xhr.responseJSON.message)
                        if (data.redirectUrl != null && data.redirectUrl != undefined) {
                            window.location = data.redirectUrl;
                        }
                    } else {
                        SwalMessage(
                            {
                                type: "error",
                                text: data.text,
                                confirmButton: translate.ok_button
                            },
                            function () {
                                if (data.redirectUrl != null && data.redirectUrl != undefined) {
                                    window.location = data.redirectUrl;
                                }
                            }
                        );


                    }

                })
                .catch((error) => {
                    // console.error('Error:', error);
                });

        })

    }


    return {
        init: function () {
            if (document.querySelector('#hotel-reservation-form [data-form-step="1"]')) {
                Step1();
            }
            else if (document.querySelector('#hotel-reservation-form [data-form-step="2"]')) {
                Step2();
            }
        }
    }
}();

$(function () {
    Hotels.init();
    Reservation.init();
});

